import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { DISCOUNT_CODE_CATEGORY_PATH } from '../../../../config/paths';

const DiscountCodeCategoryToolbar = ({ discountCodeCategoryId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton
        path={`${DISCOUNT_CODE_CATEGORY_PATH}/${discountCodeCategoryId}/edit`}
      />{' '}
    </div>
  </ButtonToolbar>
);

DiscountCodeCategoryToolbar.propTypes = {
  discountCodeCategoryId: PropTypes.number.isRequired,
};

export default DiscountCodeCategoryToolbar;
